const translations = {
    en: {
        home: "Home",
        stories: "About",
        about: "About",
        journey: "Field Needs",
        testimonies: "Testimonies",
        foundations: "Foundational",
        advanced: "Advanced",
        schedule: "Contact Us",
        contact: "Contact Us",
        give: "Give",
        languages: "Languages",
        classicalgreek: "Greek Exegesis and Preaching",
        classicalhebrew: "Hebrew Exegesis and Preaching",
        classical: "Classical",
        classicallatin: "Latin Exegesis",
        textualcriticism: "Textual Criticism",
        bibrhet: "Biblical Rhetorics",
        adultlearning: "Adult Learning",
        systematics: "Systematics ",
        otfoundations: "OT Foundations",
        ntfoundations: "NT Foundations",
        ethics: "Biblical Ethics",
        hsm: "Half Sermon Approaches",
        name: "Name",
        email: "Email",
        subscribe: "Apply",
        subscribetomagazine: "Contact Us",
        subscriptionsuccessful: "Subscription successful!",
        subscriptionfailed: "Subscription failed. Please try again.",
        description: "Message",
        freeresources: "Download Resources",
        resourceheader: "Foundational PowerPoints are under construction, please contact us via email if you are interested",
        needs_article1_title: "Priscilla's Testimony",
        needs_article2_title: "Zach's Testimony",
        audio_testimony_ryan_title: "Ryan's Testimony",
        audio_testimony_april_title: "April's Testimony",
        audio_testimony_evelyn_title: "Evelyn's Testimony",
        pleasefillallfields: "Please fill all fields",
        emailalreadysubscribed: "This email is already subscribed.",
        invaliddata: "Invalid data provided. Please check your input.",
        submitting: "Submitting...",
        pdfloading: "Loading PDF...",
        exegesis: "Exegetical Meditations",
        about_page1_title: "About Us",
        about_page2_title: "Origins",
        about_page3_title: "Educational Background",
        emailinfo: "Please email us at: ",
        comingsoon: "Coming Soon",
        comingsoon_message: "This page is coming soon. Stay tuned!",
    },
    "zh-TW": {
        home: "首頁",
        stories: "關於",
        about: "關於",
        journey: "工場需求",
        testimonies: "學習見證",
        foundations: "基礎資料",
        advanced: "高級課程",
        schedule: "聯繫我們",
        contact: "聯絡我們",
        give: "捐贈",
        languages: "語言",
        classicalgreek: "希臘文與解經",
        classicalhebrew: "希伯來文與解經",
        classical: "古典教育",
        classicallatin: "拉丁文與解經",
        textualcriticism: "經文鑒別學",
        bibrhet: "聖經修辭學",
        adultlearning: "成人教學",
        systematics: "系統神學",
        otfoundations: "舊約基礎",
        ntfoundations: "新約基礎",
        ethics: "聖經倫理學",
        hsm: "半講章方法",
        name: "姓名",
        email: "電子郵件",
        subscribe: "提交",
        subscribetomagazine: "聯絡我們",
        subscriptionsuccessful: "訂閱成功！",
        subscriptionfailed: "訂閱失敗。請再試一次。",
        description: "留言",
        freeresources: "資料下載",
        resourceheader: "基礎資料PPT製作中，請感興趣的讀者寫信聯繫我們",
        needs_article1_title: "Priscilla的見證",
        needs_article2_title: "Zach的見證",
        audio_testimony_ryan_title: "Ryan的見證",
        audio_testimony_april_title: "April的見證",
        audio_testimony_evelyn_title: "Evelyn的見證",
        pleasefillallfields: "請填寫所有欄位",
        emailalreadysubscribed: "此電子郵件已經訂閱。",
        invaliddata: "提供的數據無效。請檢查您的輸入。",
        submitting: "提交中...",
        pdfloading: "正在加載PDF...",
        exegesis: "解經小品",
        about_page1_title: "關於我們",
        about_page2_title: "起源",
        about_page3_title: "教育背景",
        emailinfo: "請透過電子郵件與我們聯繫：",
        comingsoon: "敬請期待",
        comingsoon_message: "此頁面即將推出，敬請期待！",
    },
    "zh-CN": {
        home: "主页",
        stories: "关于我们",
        about: "关于我们",
        journey: "工场需求",
        testimonies: "学习见证",
        foundations: "基础资料",
        advanced: "高级课程",
        schedule: "联系我们",
        contact: "联系我们",
        give: "捐赠",
        languages: "语言",
        classicalgreek: "希腊文与解经",
        classicalhebrew: "希伯来文与解经",
        classical: "古典教育",
        classicallatin: "拉丁文与解经",
        textualcriticism: "经文鉴别学",
        bibrhet: "圣经修辞学",
        adultlearning: "成人教学",
        systematics: "系统神学",
        otfoundations: "旧约基础",
        ntfoundations: "新约基础",
        ethics: "圣经伦理学",
        hsm: "半讲章方法",
        name: "姓名",
        email: "电子邮件",
        subscribe: "提交",
        subscribetomagazine: "联系我们",
        subscriptionsuccessful: "订阅成功！",
        subscriptionfailed: "订阅失败。请再试一次。",
        description: "留言",
        freeresources: "资料下载",
        resourceheader: "基础资料PPT制作中，请感兴趣的读者写信联系我们",
        needs_article1_title: "Priscilla的见证",
        needs_article2_title: "Zach的见证",
        audio_testimony_ryan_title: "Ryan的见证",
        audio_testimony_april_title: "April的见证",
        audio_testimony_evelyn_title: "Evelyn的见证",
        pleasefillallfields: "请填写所有字段",
        emailalreadysubscribed: "此电子邮件已经订阅。",
        invaliddata: "提供的数据无效。请检查您的输入。",
        submitting: "提交中...",
        pdfloading: "正在加载PDF...",
        exegesis: "解经小品",
        about_page1_title: "关于我们",
        about_page2_title: "起源",
        about_page3_title: "教育背景",
        emailinfo: "请通过电子邮件与我们联系：",
        comingsoon: "敬请期待",
        comingsoon_message: "此页面即将推出，敬请期待！",
    },
    "ja": {
        home: "ホーム",
        stories: "私たちについて",
        about: "私たちについて",
        journey: "工場需要",
        testimonies: "学習証言",
        foundations: "基礎",
        advanced: "上級",
        schedule: "お問い合わせ",
        contact: "お問い合わせ",
        give: "寄付",
        languages: "言語",
        classicalgreek: "ギリシャ語の解釈と説教",
        classicalhebrew: "ヘブライ語の解釈と説教",
        classical: "古典",
        classicallatin: "ラテン語と解釈学",
        textualcriticism: "テキスト批評",
        bibrhet: "聖書修辞学",
        adultlearning: "成人学習",
        systematics: "体系神学",
        otfoundations: "旧約基礎",
        ntfoundations: "新約基礎",
        ethics: "聖書倫理学",
        hsm: "半説教アプローチ",
        name: "名前",
        email: "メール",
        subscribe: "提出",
        subscribetomagazine: "お問い合わせ",
        subscriptionsuccessful: "購読成功！",
        subscriptionfailed: "購読に失敗しました。もう一度お試しください。",
        description: "メッセージ",
        freeresources: "資料ダウンロード",
        resourceheader: "基礎資料PPT作成中、ご興味のある読者の方はお手紙でご連絡ください",
        needs_article1_title: "プリシラの証言",
        needs_article2_title: "ザックの証言",
        audio_testimony_ryan_title: "ライアンの証言",
        audio_testimony_april_title: "エイプリルの証言",
        audio_testimony_evelyn_title: "エブリンの証言",
        pleasefillallfields: "すべてのフィールドに入力してください",
        emailalreadysubscribed: "このメールアドレスはすでに登録されています。",
        invaliddata: "提供されたデータが無効です。入力内容を確認してください。",
        submitting: "送信中...",
        pdfloading: "PDFを読み込み中...",
        exegesis: "解釈学的小品",
        about_page1_title: "私たちについて",
        about_page2_title: "起源",
        about_page3_title: "教育的背景",
        emailinfo: "次のメールアドレスまでご連絡ください： ",
        comingsoon: "近日公開",
        comingsoon_message: "このページは近日公開予定です。ご期待ください！",
    },
};

export default translations;
